import styled from "styled-components";

export const UserStatusRefillStyled = styled.div`
    text-align: center;
    padding: 16px;
    border-radius: var(--border-radius);
    background-color: var(--color-background-secondary);
    box-shadow: var(--shadow-primary);
`;
